import axios from "axios";
import { default as React, useEffect, useState } from "react";
import { API, api_url, generateAuthHeader } from "../../util/util";


function ProductOverview({ permalink }) {
    const [loading, setLoading] = useState(false);
    const [explainproducts, setExplainProducts] = useState(null);


    const handleExplainproducts = async () => {
        const url = `${api_url}/${API.ENDPOINTS.explainProducts}?permalink=${permalink}`;
        try {
            const response = await axios.get(url, {
                headers: {
                    "Authorization ": generateAuthHeader(),
                    "Content-Type": "application/json",
                },
            });
            console.log(response.data);
            setLoading(false);
            if (response.status === 200) {
                setExplainProducts(response.data);
            } else {
                console.error("Unexpected response");
            }
        } catch (error) {
            console.error("Error fetching suggestions:", error);
        }
    };


    useEffect(() => {
        setLoading(true);
        handleExplainproducts();
    }, []);

    return <div className="product-overview">
        {/* <h6>Overview</h6> */}
        {loading ? (
            <p></p>
        ) :explainproducts ? (
            <span >{explainproducts}</span>
        ) : (
            <p>No data available</p>
        )}
    </div>
}

export default ProductOverview;
